<template>
    <div>
        <!-- Domain Connection button  -->
        <slot name="button"
              v-if="this.user_info.email == 'alexandre.landskron@gmail.com'">
            <a href="#"
               data-toggle="modal" data-target="#domainConnectionModal"
               class="btn btn btn-primary"
               id="btn-domain-connection"
               @click="domain=''">
                    Connect your domain
            </a>
        </slot>

        <!-- Domain Connection Modal -->
        <div class="modal fade" tabindex="-1" role="dialog" id="domainConnectionModal" data-backdrop="false" :class="{in : modalShow}">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header is-success">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><i class="fa fa-bullhorn"></i><span v-html="translation.title"></span></h4>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="title__submit__common input-share-label" ><span v-html="translation.label_use_your_domain"></span></label><br>
                                    <input type="text" class="form-control input-share" v-model.trim="domain" required="required" placeholder="example.com">
                                </div>
                                <p style="margin-top:20px;">
                                    <span v-html="translation.info_dns"></span>
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-footer">
                        <button style="float:left" 
                                class="btn btn--def btn-danger" 
                                data-dismiss="modal"
                                id="btn-close-modal-vis">
                                    <span v-if="!connecting">Close</span>
                                    <span v-if="connecting" :class="{disabled : connecting}">Close</span>
                        </button>
                        <button style="float:right" 
                                class="btn btn--def button__transparent" 
                                :class="{disabled : connecting}"
                                @click="startDomainConnection()"
                                id="btn-domain-connection-confirm">
                                    <span v-if="!connecting" v-html="translation.btn_connect"></span>
                                    <span v-if="connecting"><i class="fa fa-spinner fa-spin fa-2x"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div> 
        <!-- end of domain connection modal -->
    </div>
</template>

<script>
    import qs from 'qs';

    export default {
        name: "domain-connection",
        props: [
            "translation",
            "challenge_funnel",
            "user_info"
        ],
        mounted() {
            // console.log('mouted');
        },
        data() {
            return {
                id_layout_challenge_funnel   : this.challenge_funnel.id_layout_challenge_funnel,
                user_info                    : this.user_info,
                modalShow                    : true,
                connecting                   : false,
                domain                       : '',
                isDomainBlockedURL           : '/' + lang + '/office/site-builder/domain-name-is-blocked',
                domainConnectionURL          : '/' + lang + '/office/franchise-system/share/domain',
                multipleDomainsConnectionURL : '/' + lang + '/office/connect-resource-domain-sitebuilder'
            }
        },
        methods: {
            /**
             * Connects the domain into the funnels
             */
            async startDomainConnection() {
                try {
                    this.connectingLayout(true);

                    if(this.id_layout_challenge_funnel == '') throw new Error('ID Funnel Not Identified');

                    // console.log('domain checking...');
                    let isDomainNameBlocked = await this.isDomainNameBlocked(this.domain, 0);
                    if(isDomainNameBlocked == true) {
                        this.connectingLayout(false);
                        throw new Error('Domain blocked: ' + this.domain);
                    }

                    // console.log('domain connecting...');

                    let domainConnected = await this.connectDomain(this.domain);
                    if(domainConnected != 'success') {
                        this.connectingLayout(false);
                        throw new Error('An error has ocurred during the connection: ' + domainConnected.msg);
                    }

                    // console.log('multiple domain connecting...');

                    let multipledomainConnected = await this.connectMultipleDomain(this.domain);
                    if(multipledomainConnected != 'success') {
                        this.connectingLayout(false);
                        throw new Error('An error has ocurred during the connection: ' + domainConnected.msg);
                    }

                    this.connectingLayout(false);
                    // console.log('domain connected');
                    let successMsg = 'Domain connected!';
                    alertMsg('success', successMsg);

                    this.closeConnectionModal();

                }catch(error) {
                    this.connectingLayout(false);
                    let errorMsg = 'Domain not connected | ' + error;
                    console.log(errorMsg);
                    alertMsg('error', errorMsg);
                }
                                
            },
            /**
             * Set connecting process layout
             * @param {boolean} status
             */
            connectingLayout(status) {
                this.connecting = status;
            },

            /**
             * Closes the connection modal searching by the element
             */
            closeConnectionModal() {
                this.modalShow = false;
                document.getElementById("btn-close-modal-vis").click();
            },

            /**
             * Checks if the domain cotains some blocked keyword or blocked extension
             * 
             * @param {string}  domain 
             * @param {boolean} is_domain_purchase 
             */
            async isDomainNameBlocked(domain, is_domain_purchase) {
                let domainData = {
                    domain             : domain,
                    is_domain_purchase : is_domain_purchase
                };

                let domainBlockedData = await axios
                    .post(
                        this.isDomainBlockedURL, 
                        qs.stringify(domainData)
                    )
                    .then(response => {
                        if (response.status == 200) {
                            return response.data;
                        }else{
                            throw new Error('Error Requesting Domain Blocked API ');
                        }
                    })
                    .catch(error => {
                        console.log("erro", error, error.response);
                    });


                return new Promise(resolve=> {
                    resolve(domainBlockedData.status);
                });
            },

            /**
             * Connects the domain
             * 
             * @param {string}  domain 
             */
            async connectDomain(domain) {
                const data = {
                    domain : this.domain
                };

                let domainConnection = await axios
                    .post(
                        this.domainConnectionURL, 
                        qs.stringify(data)
                    )
                    .then(response => {
                        if (response.status == 200) {
                            return response.data;
                        }else{
                            throw new Error('Error Requesting Connect API ');
                        }
                    })
                    .catch(error => {
                        console.log("erro", error, error.response);
                    });

                return new Promise(resolve=> {
                    resolve(domainConnection.status);
                });
            },

            /**
             * Connects the domain to the multiple domains tables
             * 
             * @param {string}  domain 
             */
            async connectMultipleDomain(domain) {
                const data = {
                    domain    : this.domain,
                    id_layout : this.id_layout_challenge_funnel
                };

                let multipleDomainConnection = await axios
                    .post(
                        this.multipleDomainsConnectionURL, 
                        qs.stringify(data)
                    )
                    .then(response => {
                        if (response.status == 200) {
                            return response.data;
                        }else{
                            throw new Error('Error Requesting Multiple Domains API ');
                        }
                    })
                    .catch(error => {
                        console.log("erro", error, error.response);
                    });

                return new Promise(resolve=> {
                    resolve(multipleDomainConnection.status);
                });
            }
            // end of methods
        }
    };

</script>

<style scoped lang="scss">
    #btn-domain-connection {
        margin-left : 25px;
    }
    #btn-domain-connection-confirm {
        margin-right: 15px;
        cursor                : pointer;
        text-align            : center;
        display               : inline-block;
        font-size             : 0.7857rem;
        letter-spacing        : 0.1px;
        font-weight           : normal;
        text-transform        : uppercase;
        outline               : none;
        font-family           : Muli-Bold;
        z-index               : 1;
        transition            : all 0.5s ease;
        margin-bottom         : 3px;
        padding               : 0px 0px !important;
        background            : transparent;
        color                 : #0294ff;
        border                : none;
        border-radius         : 6px;
        -moz-border-radius    : 6px;
        -webkit-border-radius : 6px;
        -o-border-radius      : 6px;
        -ms-border-radius     : 6px;
    }
    
    #btn-domain-connection-confirm:hover {
        -webkit-box-shadow: 0px 6px 30px -10px #0294ff;
        -moz-box-shadow: 0px 6px 30px -10px #0294ff;
        box-shadow: 0px 6px 30px -10px #0294ff;
    }

    #btn-close-modal-vis {
        margin-left: 15px;
        cursor                : pointer;
        text-align            : center;
        display               : inline-block;
        font-size             : 0.7857rem;
        letter-spacing        : 0.1px;
        font-weight           : normal;
        text-transform        : uppercase;
        outline               : none;
        font-family           : Muli-Bold;
        z-index               : 1;
        transition            : all 0.5s ease;
        margin-bottom         : 3px;
        padding               : 0px 0px !important;
        background            : transparent;
        color                 : #d9534f;
        border                : none;
        border-radius         : 6px;
        -moz-border-radius    : 6px;
        -webkit-border-radius : 6px;
        -o-border-radius      : 6px;
        -ms-border-radius     : 6px;
    }

    #btn-close-modal-vis:hover {
        -webkit-box-shadow: 0px 6px 30px -10px #d9534f;
        -moz-box-shadow: 0px 6px 30px -10px #d9534f;
        box-shadow: 0px 6px 30px -10px #d9534f;
    }

    #domainConnectionModal {
        position   : relative;
        margin-top : -58vh;
    }

</style>


// WEBPACK FOOTER //
// resources/office/js/components/DomainConnection.vue